import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard to protect routes that require authentication.
 * Redirects unauthenticated users to the login page.
 * Attempts to refresh expired tokens before redirecting.
 */
@Injectable({
  providedIn: 'root',
})
export class AfterLoginGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Check if user has valid session
    if (this.authService.isAuthenticated()) {
      return true;
    }

    // If access token expired but refresh token is valid, attempt refresh
    if (
      this.authService.isTokenExpired() &&
      !this.authService.isRefreshTokenExpired()
    ) {
      return this.authService.refreshToken().then((success) => {
        if (success) {
          return true;
        }
        return this.router.createUrlTree(['', 'login']);
      });
    }

    // No valid session, redirect to login
    return this.router.createUrlTree(['', 'login']);
  }
}
